// extracted by mini-css-extract-plugin
export default {"mainContainer":"bb_j6"};